import { Injectable } from '@angular/core';
import { draw, cvGetFileDataToSave } from 'src/assets/js/draw';
import { FileManagerService } from '@app/features/student/services/file-manager.service';
import { CV_ABC_TYPE, CV_SPEC2_GRP } from '../constant/canvasSymTypes';

@Injectable({
  providedIn: 'root',
})
export class TabbingService {
  // accessTrianglePopup: boolean = false;
  accessTrianglePopup: boolean = true;

  constructor(private readonly fileManagerService: FileManagerService) {}

  toggleTrianglePopup() {
    this.accessTrianglePopup = !this.accessTrianglePopup;
  }

  moveElement(elementId: string, event?: Event) {
    if (elementId) {
      if (event) {
        event.preventDefault();
      }
      setTimeout(() => {
        const targetElement = document.getElementById(elementId);
        if (targetElement) {
          targetElement.focus();
        }
      }, 0);
    }
  }
  // when shift is pressed
  moveFromFirstToLast(event: KeyboardEvent, lastElementId: string, firstSiblingId?: string) {
    if ((event.key === 'Enter' || event.key === '\\') && firstSiblingId) {
      this.moveElement(firstSiblingId);
    } else if (event.key === 'Tab') {
      if (event.shiftKey) {
        event.preventDefault();
        this.moveElement(lastElementId);
      }
    }
  }

  drawInCanvas(mathKeyID: any) {
    const groupCode = CV_SPEC2_GRP;
    const typeCode = CV_ABC_TYPE;
    draw(mathKeyID, groupCode, typeCode);
    this.fileManagerService.shouldSaveFile = true;
    this.fileManagerService.updateCurrentFileData(cvGetFileDataToSave());
  }
}
